module.exports = __webpack_public_path__ + "img/ep-etoile-2.3db4f3c7.jpg";